import React, { Component } from 'react';
import Table from '../../../components/common/Table';

class PushSubscribersTable extends Component {
    render() {
        const {  subscribers, onClick, onSort, sortColumn } = this.props;

        const columns = [
            {path: "id", label: "Subscriber ID"},
            {path: "created_at", label: "Registered"},
            {path: "updated_at", label: "Last Active"},
            // {path: "open_rate", label: "Open Rate",
            //     content: item => <div>
            //         <div className={item.open_rate_class || "active avg"}></div>
            //         {item.open_rate || "0%"}
            //     </div>},
            {path: "distribution_method", label: "Distribution Method",
                content: item => <div>
                    <span className="fas fa-globe"></span>{item.feed_name || item.user_id}
                </div>}

        ];
        return (

            <Table
                data={subscribers}
                columns={columns}
                sortColumn={sortColumn}
                onSort={onSort}
                onClick={onClick}/>
        );
    }
}

export default PushSubscribersTable